import React, { useEffect, useState } from 'react';

import TabSOuts from './TabsExchange1S/TabSOuts';
import { Tab, Tabs } from '../../components/Tabs';
import BackBtn from '../../components/UI/BackBtn';

const tabs = [
  { label: 'souts', tabName: 'Закупки в 1С', content: TabSOuts },
  // {label: 'sins', tabName: 'Отчеты из 1С', content: TabSIns},
];

export default function AdminExchange1S() {
  return (
    <section className="page admin-fundings-plans-page">
      <div className="container">
        <BackBtn />
        <div style={{ marginTop: 20 }}>
          <Tabs>
            {tabs
              .map((tab, i) => (
                <Tab key={i} label={tab.label} tabName={tab.tabName}>
                  <tab.content />
                </Tab>
              ))}
          </Tabs>
        </div>
      </div>
    </section>
  );
}
